<div class="h-full overflow-y-scroll bg-surface">
  <div class="fixed z-sticky flex h-12 w-full flex-1 items-center justify-center xl:justify-start xl:pl-4">
    <a class="flex h-full items-center py-3">
      <sb-logo class="w-36" />
    </a>
  </div>

  <div class="mt-10 flex justify-center">
    <div class="flex max-w-2xl grow flex-col justify-center gap-6 px-5 py-10">
      @if (steps) {
        <div class="mb-6">
          <sb-progress-bar
            [title]="
              'Step [currentStep] of [totalSteps]'
                | translate: { currentStep: currentStepIndex + 1, totalSteps: steps.length }
            "
            [level]="progress"
          />
        </div>
      }
      @if (subscription?.plan; as plan) {
        @switch (steps[currentStepIndex]) {
          @case (downgradeSteps.INTRO) {
            <app-downgrade-intro [planName]="plan.name" [isFreeDowngrade]="isFreeDowngrade" (next)="advance()" />
          }
          @case (downgradeSteps.LOCATIONS) {
            <app-downgrade-locations [planName]="plan.name" [subscriptionPlanQuotas]="plan.quotas" (next)="advance()" />
          }
          @case (downgradeSteps.EMPLOYEES) {
            <app-downgrade-employees
              [planName]="plan.name"
              [subscriptionPlanQuotas]="plan.quotas"
              (next)="advance()"
              (back)="goBack()"
            />
          }
        }
      } @else {
        <div class="flex justify-center py-2xl">
          <sb-spinner [strokeColor]="'grey'" />
        </div>
      }
    </div>
  </div>
</div>
